import React from 'react';
import Img1 from '../images/Download.png';
import { LineChart, Line, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar, Legend } from 'recharts';
import Download1 from '../images/Group 2218.svg';
import PlaySecond from '../images/play-colored.png';
import Apple from '../images/apple.png';
import Android from '../images/android.png';
import MoreButton from '../images/More Button.svg';
import MoreButton2 from '../images/Group 72.svg';
import MoreButton3 from '../images/MoreButtonVideo.svg';
import MoreButton4 from '../images/MoreButtonWhatsNew.svg';
import Group from '../images/Group 2250.svg';
import ArrowRight from '../images/arrow-right.png';
import Arrow from '../images/arrow.png';
import favicon from '../images/favicon.svg';
import Copy from '../images/copy.svg';
import foot7 from '../images/Footstep7.svg';
import scope from '../images/scope.svg';
import nonu from '../images/nonu.svg';
import _ from 'lodash';
import '../css/dashboardContent.css';
import okasdesignstudiosmall from '../images/okasdesignstudiosmall.png';
import weokassmall from '../images/weokassmall.png';
import Help from '../images/headericon/Help.svg';
import GridViewBlue from '../images/headericon/GridViewBlue.svg';
import GridViewGray from '../images/headericon/GridViewGray.svg';
import ListViewBlue from '../images/headericon/ListViewBlue.svg';
import ListViewGray from '../images/headericon/ListViewGray.svg';
import RegisterdOkasBoxes from '../images/headericon/RegisterdOkasBoxes.svg';
import RemainingOkasBoxes from '../images/headericon/RemainingOkasBoxes.svg';
import CompleteProject from '../images/headericon/CompleteProject.svg';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Icon from 'react-icons-kit';
import { connect } from 'react-redux';
import * as ActionTypes from '../actions/types';
import Style from 'style-it';
import {
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
} from "@mui/material";


class DashboardContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            okasBoxData: [],
            projectdet: [],
            kk: 'asdvhj',
            assignCount: 0,
            unAssignCount: 0,
            totalBoxes: 0,
            hideGridView: true,
            hoveredId: null,
            totalregboxnumber: 0,
            revenue_data: [],
            initial_box: 80,
            growth: 40,
            ticketdata1: [],
            totalSiData: [],
            assigned_inventory_chart: [],
            ticketid: '',
            currentPage: 1,
            notification1: 0,
            todosPerPage: 10,
            totalprojectdone: 0,
            okasBoxDataUnassign: [],
            knowledgeBank: [],
            upcommingEvents: [],
            videoItems: [],
            whatsNew: [],
            okasBoxDataAll: [],
            okasBoxDataAssign: [],
            isModalOpen: false,
            isModalOpen2: false,
            videoId: "", // To store the video URL
            whatsNewId: '',
            firstChartFilter: "all",
            secondChartFilter: "all",
            registered_okas_invetory_chart: [],
            remaining_okas_invetory_chart: [],
            si_chart: [],
            inventory_mapping: [],
            registered_okas_invetory_chart_1: [],
        };
        this.handleClickpage = this.handleClickpage.bind(this);
    }


    // Function to open the modal and pass the video URL
    openModal = (videoId) => {
        this.setState({
            videoId: videoId, // Set the video URL
            isModalOpen: true,   // Open the modal
        });
    };
    // Function to open the modal and pass the video URL
    openModal2 = (whatsNewId) => {
        this.setState({
            whatsNewId: whatsNewId, // Set the video URL
            isModalOpen2: true,   // Open the modal
        });
    };

    closeModal = () => {
        this.setState({
            isModalOpen: false, // Close the modal
        });
    };

    closeModal2 = () => {
        this.setState({
            isModalOpen2: false, // Close the modal
        });
    };




    handleClickpage(event, position) {
        let pageNo = 0;
        if (position === 'position') {
            pageNo = event
        } else {
            pageNo = event.target.id
        }

        this.setState({
            currentPage: Number(pageNo)
        });
        this.renderTableData('type1');
        this.renderTableData('pagination');
    }

    componentWillMount() {
        this.fetchOkasBoxUnassign();
        this.fetchOkasBoxAssign();
        this.fetchAllBox();
        this.fetchKnowledgeBank();
        this.fetchUpcommingEvents();
        this.fetchVideos();
        this.fetchWhatsNew();
    }

    fetchKnowledgeBank = () => {

        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }

        fetch('/we/knowledge-bank/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(knowledgeData => {
                this.setState({
                    knowledgeBank: knowledgeData
                })
                // console.log(this.state.knowledgeBank)
            })

    }
    fetchUpcommingEvents = () => {

        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }

        fetch('/we/events/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(upcommingEventsData => {
                this.setState({
                    upcommingEvents: upcommingEventsData
                })
                // console.log(this.state.upcommingEvents)
            })

    }

    fetchVideos = () => {

        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
        }

        fetch('/we/video-library/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(videoData => {
                this.setState({
                    videoItems: videoData
                })
                // console.log(this.state.videoItems)
            })

    }

    fetchWhatsNew = () => {

        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue
        }

        fetch('/we/whats-new/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(whatsNewData => {
                this.setState({
                    whatsNew: whatsNewData
                })
                // console.log(this.state.whatsNew)
            })

    }



    fetchOkasBoxUnassign = () => {
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }

        fetch('/we/we/okasunassigneddata/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(okasBoxData => {
                this.setState({
                    okasBoxDataUnassign: okasBoxData
                })
                // console.log(this.state.okasBoxDataUnassign)
            })
    }

    fetchOkasBoxAssign = () => {
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }

        fetch('/we/we/okasassigneddata/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(okasBoxData => {
                this.setState({
                    okasBoxDataAssign: okasBoxData
                })
                // console.log(this.state.okasBoxDataAssign)
            })
    }

    fetchAllBox = () => {
        this.setState({
            loader: true,
        })
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }

        fetch('/we/we/okastabledata/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(okasBoxData => {
                this.setState({
                    okasBoxDataAll: okasBoxData,
                })
                this.setState({
                    loader: false,
                })
            })
    }


    // !st Chart Graph //


    GetRegisteredInventory(data, type = "all", is_rmailing = false, is_assigned = false) {
        const today = new Date();
        const currentYear = today.getFullYear();
        const currentMonth = today.getMonth(); // 0-based month index (0 = January, 11 = December)

        // Filter data based on "okasBox_assigned_to" and "is_rmailing"
        if (is_rmailing) {
            data = data.filter(item => item.user === "unassigned");
        }

        // Filter data based on "okasBox_assigned_to" and "is_rmailing"
        if (is_assigned) {
            data = data.filter(item => item.user !== "unassigned");
        }
        // console.log(data)
        if (type === "lastMonth") {
            // const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();

            // const result = Array.from({ length: daysInMonth }, (_, index) => ({
            //     key: new Date(currentYear, currentMonth, index + 1).toISOString().split('T')[0].slice(8), // YYYY-MM-DD
            //     count: 0,
            // }));

            // data.forEach(item => {
            //     if (item.assigned_at) {
            //         const assignedDate = new Date(item.assigned_at);
            //         if (
            //             assignedDate.getFullYear() === currentYear &&
            //             assignedDate.getMonth() === currentMonth
            //         ) {
            //             const day = assignedDate.getDate(); // Day of the month (1-based)
            //             result[day - 1].count += 1; // Increment the count for the corresponding day
            //         }
            //     }
            // });


            // return result;
            // Helper function to format date as 'YYYY-MM-DD'
            const formatDate = (dateString) => {
                const date = new Date(dateString);
                return `${String(date.getDate()).padStart(2, '0')}`;
            };

            // Get the current date and calculate the first and last day of the previous month
            const currentDate = new Date();
            const firstDayLastMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
            const lastDayLastMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

            // Initialize a Map to count occurrences for each day of last month
            const countsByDay = new Map();

            // Populate the Map based on the assigned_at field
            data.forEach((item) => {
                if (item.assigned_at) {
                    const assignedDate = new Date(item.assigned_at);
                    if (assignedDate >= firstDayLastMonth && assignedDate <= lastDayLastMonth) {
                        const dayKey = formatDate(assignedDate.toISOString());
                        countsByDay.set(dayKey, (countsByDay.get(dayKey) || 0) + 1);
                    }
                }
            });

            // Generate all days of the last month with counts
            const result = [];
            let currentDay = new Date(firstDayLastMonth);

            while (currentDay <= lastDayLastMonth) {
                const dayKey = formatDate(currentDay.toISOString());
                result.push({
                    key: dayKey,
                    count: countsByDay.get(dayKey) || 0,
                });
                // Move to the next day
                currentDay.setDate(currentDay.getDate() + 1);
            }

            return result;
        } else if (type === "currentYear") {
            const months = Array.from({ length: currentMonth + 1 }, (_, index) => ({
                key: new Date(currentYear, index, 1).toLocaleString('default', { month: 'short' }), // Month name
                count: 0,
            }));

            data.forEach(item => {
                if (item.assigned_at) {
                    const assignedDate = new Date(item.assigned_at);
                    if (assignedDate.getFullYear() === currentYear) {
                        const monthIndex = assignedDate.getMonth(); // 0-based
                        if (monthIndex <= currentMonth) {
                            months[monthIndex].count += 1;
                        }
                    }
                }
            });

            return months;
        } else if (type === "all") {
            // const yearCounts = {};

            // data.forEach(item => {
            //     if (item.assigned_at) {
            //         const assignedDate = new Date(item.assigned_at);
            //         // const year = assignedDate.getFullYear();
            //         yearCounts[assignedDate] = (yearCounts[year] || 0) + 1;
            //     }
            // });

            // return Object.entries(yearCounts).map(([key, count]) => ({
            //     key,
            //     count,
            // }));
            // Helper function to format date as 'YYYY-MM'
            const formatMonth = (dateString) => {
                const date = new Date(dateString);
                return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
            };

            // Create a Map to count boxes assigned per month
            const countsByMonth = new Map();

            data.forEach((item) => {
                const monthKey = formatMonth(item.assigned_at);
                countsByMonth.set(monthKey, (countsByMonth.get(monthKey) || 0) + 1);
            });

            // Get the range of months from the least date to the current date
            const assignedDates = data.map((item) => new Date(item.assigned_at));
            const minDate = new Date(Math.min(...assignedDates));
            const currentDate = new Date(); // Use current date as max

            // const formattedMin = formatMonth(minDate.toISOString());
            // const formattedCurrent = formatMonth(currentDate.toISOString());

            // Generate all months in the range
            const result = [];
            let currentMonth = new Date(minDate.getFullYear(), minDate.getMonth(), 1);

            while (currentMonth <= currentDate) {
                const monthKey = formatMonth(currentMonth.toISOString());
                result.push({
                    key: monthKey,
                    count: countsByMonth.get(monthKey) || 0,
                });
                // Move to the next month
                currentMonth.setMonth(currentMonth.getMonth() + 1);
            }

            return result;
        }

        return [];
    }


    // !st Chart Graph End //


    // 2st Chart Grapgh Total Start // 

    GetTotalModifiedData(data, type = "all") {
        const today = new Date();
        const currentYear = today.getFullYear();
        const currentMonth = today.getMonth(); // 0-based month index (0 = January, 11 = December)

        if (type === "lastMonth") {
            // const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();

            // const result = Array.from({ length: daysInMonth }, (_, index) => ({
            //     key: new Date(currentYear, currentMonth, index + 1).toISOString().split('T')[0], // YYYY-MM-DD
            //     count: 0,
            // }));

            // data.forEach(item => {
            //     if (item.modified) {
            //         const modifiedDate = new Date(item.modified);
            //         if (
            //             modifiedDate.getFullYear() === currentYear &&
            //             modifiedDate.getMonth() === currentMonth
            //         ) {
            //             const day = modifiedDate.getDate(); // Day of the month (1-based)
            //             result[day - 1].count += 1; // Increment the count for the corresponding day
            //         }
            //     }
            // });

            // return result;
            // Helper function to format date as 'YYYY-MM-DD'
            const formatDate = (dateString) => {
                const date = new Date(dateString);
                return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
            };

            // Get the current date and calculate the first and last day of the previous month
            const currentDate = new Date();
            const firstDayLastMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
            const lastDayLastMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

            // Initialize a Map to count occurrences for each day of last month
            const countsByDay = new Map();

            // Populate the Map based on the modified field
            data.forEach((item) => {
                if (item.created) {
                    const createdDate = new Date(item.created);
                    if (createdDate >= firstDayLastMonth && createdDate <= lastDayLastMonth) {
                        const dayKey = formatDate(createdDate.toISOString());
                        countsByDay.set(dayKey, (countsByDay.get(dayKey) || 0) + 1);
                    }
                }
            });

            // Generate all days of the last month with counts
            const result = [];
            let currentDay = new Date(firstDayLastMonth);

            while (currentDay <= lastDayLastMonth) {
                const dayKey = formatDate(currentDay.toISOString());
                result.push({
                    key: dayKey,
                    count: countsByDay.get(dayKey) || 0,
                });
                // Move to the next day
                currentDay.setDate(currentDay.getDate() + 1);
            }

            return result;
        } else if (type === "currentYear") {
            const months = Array.from({ length: currentMonth + 1 }, (_, index) => ({
                key: new Date(currentYear, index, 1).toLocaleString('default', { month: 'long' }), // Month name
                count: 0,
            }));

            data.forEach(item => {
                if (item.created) {
                    const modifiedDate = new Date(item.created);
                    if (modifiedDate.getFullYear() === currentYear) {
                        const monthIndex = modifiedDate.getMonth(); // 0-based
                        if (monthIndex <= currentMonth) {
                            months[monthIndex].count += 1;
                        }
                    }
                }
            });

            return months;
        } else if (type === "all") {
            // Helper function to format date as 'YYYY-MM'
            const formatMonth = (dateString) => {
                const date = new Date(dateString);
                return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
            };

            // Create a Map to count creations per month
            const countsByMonth = new Map();

            data.forEach((item) => {
                const monthKey = formatMonth(item.created);
                countsByMonth.set(monthKey, (countsByMonth.get(monthKey) || 0) + 1);
            });

            // Get the range of months from the least date to the current date
            const createdDates = data.map((item) => new Date(item.created));
            const minDate = new Date(Math.min(...createdDates));
            const currentDate = new Date(); // Use current date as max

            // const formattedMin = formatMonth(minDate.toISOString());
            // const formattedCurrent = formatMonth(currentDate.toISOString());

            // Generate all months in the range
            const result = [];
            let currentMonth = new Date(minDate.getFullYear(), minDate.getMonth(), 1);

            while (currentMonth <= currentDate) {
                const monthKey = formatMonth(currentMonth.toISOString());
                result.push({
                    key: monthKey,
                    count: countsByMonth.get(monthKey) || 0,
                });
                // Move to the next month
                currentMonth.setMonth(currentMonth.getMonth() + 1);
            }

            return result;
        }

        return [];
    }


    // 2st Chart Grapgh Total End // 



    componentDidMount() {

        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        fetch('/we/okastabledata/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(projectdet => {
                const result = _.filter(projectdet, word => word.assigned_to !== 'unassigned');
                // const result = projectdet.filter(word => word.assigned_to!=='unassigned');  
                this.setState({
                    totalregboxnumber: projectdet.length,
                    assignCount: result.length,
                    unAssignCount: projectdet.length - result.length,
                })
                // console.log(projectdet) 
            })

        fetch('/we/we/addSI/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(siData => {
                this.setState({
                    totalSiData: siData.si_data,
                    siBoxData: siData.si_box,
                    loader: false,
                })
                // console.log('siBoxData:', this.state.totalSiData)
            })

        fetch('/we/we/ticketApi/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(ticketdata1 => {
                if (ticketdata1[0]) {
                    this.setState({
                        ticketdata1: ticketdata1,
                        ticketid: ticketdata1[0].ticket_id,
                        ticketstatus: ticketdata1[0].status,
                        ticketsubject: ticketdata1[0].subject,
                        ticketdescription: ticketdata1[0].description,
                    }, () => {
                        this.renderTableData("ticketdata");
                        // console.log(this.state.ticketdata1)
                        // console.log(this.state.ticketid)
                    })
                    this.setState({
                        loader: false,
                    })
                } else {
                    this.setState({
                        ticketdata1: '',
                        ticketid: '',
                        ticketstatus: '',
                        ticketsubject: '',
                        ticketdescription: '',
                    })
                    this.setState({
                        loader: false,
                    })
                }

            })

        // Revenue Chart
        const data = this.predictGrowth(this.state.initial_box, 250000, this.state.growth, 6, 25000)
        // console.log(data)
        this.setState({ revenue_data: data })


    }
    GetMaxCount(data) {
        return data.reduce((max, item) => (item.count > max.count ? item : max), data[0]);
    }
    CalculateSum(data) {
        return data.reduce((sum, item) => sum + item.count, 0);
    }
    getInvetoryMapping(data, type) {

        if (type === "lastYear") {
            // Helper function to extract the year and month from a date string
            const getYearMonth = (dateString) => {
                const date = new Date(dateString);
                return { year: date.getFullYear(), month: date.getMonth() + 1 }; // Month is 0-indexed
            };

            // Helper function to get short month name
            const getMonthShortName = (month) => {
                const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                return monthNames[month - 1];
            };

            // Get the current year and last year
            const currentYear = new Date().getFullYear();
            const lastYear = currentYear - 1;

            // Initialize a Map to count occurrences for each month of the last year
            const countsByMonth = new Map();

            // Populate counts for the last year
            data.forEach((item) => {
                if (item.assigned_at) {
                    const { year, month } = getYearMonth(item.assigned_at);

                    // Only consider data from the last year
                    if (year === lastYear) {
                        const status = item.okasBox_assigned_to === "unassigned" ? "unassigned" : "assigned";
                        const key = `${year}-${month}`;

                        // Initialize month entry if it doesn't exist
                        if (!countsByMonth.has(key)) {
                            countsByMonth.set(key, { unassigned: 0, assigned: 0 });
                        }

                        // Increment the appropriate status count
                        countsByMonth.get(key)[status]++;
                    }
                }
            });

            // Ensure all months of the last year are included in the Map
            for (let month = 1; month <= 12; month++) {
                const key = `${lastYear}-${month}`;
                if (!countsByMonth.has(key)) {
                    countsByMonth.set(key, { unassigned: 0, assigned: 0 });
                }
            }

            // Carry forward unassigned counts
            let carryForwardUnassigned = 0;
            const result = Array.from(countsByMonth.entries())
                .sort(([a], [b]) => {
                    const [yearA, monthA] = a.split("-").map(Number);
                    const [yearB, monthB] = b.split("-").map(Number);
                    return yearA === yearB ? monthA - monthB : yearA - yearB;
                })
                .map(([key, counts]) => {
                    const [year, month] = key.split("-").map(Number);
                    const currentUnassigned = counts.unassigned + carryForwardUnassigned;
                    carryForwardUnassigned = currentUnassigned; // Carry forward to the next month
                    return {
                        key: `${getMonthShortName(month)}`, // Format as "Month-Year"
                        unassigned: currentUnassigned,
                        assigned: counts.assigned,
                    };
                });

            return result;

        } else if (type === "lastMonth") {
            console.log(data)
            // Helper function to extract the year, month, and day from a date string
            const getYearMonthDay = (dateString) => {
                const date = new Date(dateString);
                return { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
            };

            // Helper function to get short month name
            const getMonthShortName = (month) => {
                const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                return monthNames[month - 1];
            };

            // Get the current date
            const currentDate = new Date();

            // Determine the last month and year
            const lastMonth = currentDate.getMonth() === 0 ? 12 : currentDate.getMonth();
            const lastMonthYear = currentDate.getMonth() === 0 ? currentDate.getFullYear() - 1 : currentDate.getFullYear();

            // Get the number of days in the last month
            const daysInLastMonth = new Date(lastMonthYear, lastMonth, 0).getDate();

            // Initialize a Map to count occurrences for each date of the last month
            const countsByDate = new Map();

            data.forEach((item) => {
                if (item.assigned_at) {
                    const { year, month, day } = getYearMonthDay(item.assigned_at);

                    // Only consider data from the last month
                    if (year === lastMonthYear && month === lastMonth) {
                        const status = item.okasBox_assigned_to === "unassigned" ? "unassigned" : "assigned";
                        const key = `${year}-${month}-${day}`;

                        // Initialize date entry if it doesn't exist
                        if (!countsByDate.has(key)) {
                            countsByDate.set(key, { unassigned: 0, assigned: 0 });
                        }

                        // Increment the appropriate status count
                        countsByDate.get(key)[status]++;
                    }
                }
            });

            // Ensure all dates of the last month are included in the Map
            for (let day = 1; day <= daysInLastMonth; day++) {
                const key = `${lastMonthYear}-${lastMonth}-${day}`;
                if (!countsByDate.has(key)) {
                    countsByDate.set(key, { unassigned: 0, assigned: 0 });
                }
            }
            // console.log(countsByDate)
            // Carry forward unassigned counts
            let carryForwardUnassigned = 0;
            const result = Array.from(countsByDate.entries())
                .sort(([a], [b]) => {
                    const [yearA, monthA, dayA] = a.split("-").map(Number);
                    const [yearB, monthB, dayB] = b.split("-").map(Number);
                    return yearA === yearB ? (monthA === monthB ? dayA - dayB : monthA - monthB) : yearA - yearB;
                })
                .map(([key, counts]) => {
                    const [year, month, day] = key.split("-").map(Number);
                    const currentUnassigned = counts.unassigned + carryForwardUnassigned;
                    carryForwardUnassigned = currentUnassigned; // Carry forward to the next day
                    return {
                        key: `${day}`, // Format as "Day-Month-Year"
                        unassigned: currentUnassigned,
                        assigned: counts.assigned,
                    };
                });

            return result;
        }
        else {
            // Helper function to extract the year from a date string
            const getYear = (dateString) => new Date(dateString).getFullYear();

            // Initialize a Map to count occurrences for each year based on the assignment status
            const countsByYear = new Map();

            data.forEach((item) => {
                if (item.assigned_at) {
                    const year = getYear(item.assigned_at);
                    const status = item.okasBox_assigned_to === "unassigned" ? "unassigned" : "assigned";

                    // Initialize year entry if it doesn't exist
                    if (!countsByYear.has(year)) {
                        countsByYear.set(year, { unassigned: 0, assigned: 0 });
                    }

                    // Increment the appropriate status count
                    countsByYear.get(year)[status]++;
                }
            });

            // Get the current year and the range of years to include
            const currentYear = new Date().getFullYear();
            const earliestYear = Math.min(...data.map((item) => getYear(item.assigned_at)));

            // Ensure every year from earliestYear to currentYear is included in the Map
            for (let year = earliestYear; year <= currentYear; year++) {
                if (!countsByYear.has(year)) {
                    countsByYear.set(year, { unassigned: 0, assigned: 0 });
                }
            }

            // Carry forward unassigned counts
            let carryForwardUnassigned = 0;
            const result = Array.from(countsByYear.entries())
                .sort(([a], [b]) => a - b)
                .map(([year, counts]) => {
                    const currentUnassigned = counts.unassigned + carryForwardUnassigned;
                    carryForwardUnassigned = currentUnassigned; // Carry forward to the next year
                    return {
                        key: year,
                        unassigned: currentUnassigned,
                        assigned: counts.assigned,
                    };
                });

            return result;


        }
    }


    componentDidUpdate(prevProps, prevState) {

        function combineArraysByCount(array1, array2) {
            const result = [];

            array1.forEach(item1 => {
                const item2 = array2.find(item => item.key === item1.key);
                result.push({
                    key: item1.key,
                    assigned: item1.count || 0,
                    in_project: item2 ? item2.count || 0 : 0,
                });
            });

            return result;
        }



        const data = this.state.okasBoxDataAll;
        const si_data = this.state.totalSiData

        const date_filter = this.state.firstChartFilter;
        const date_filter_1 = this.state.secondChartFilter;

        // Check if data or date_filter has changed to prevent unnecessary updates
        if (
            data.length > 0 &&
            (prevState.okasBoxDataAll !== data || prevState.firstChartFilter !== date_filter || prevState.secondChartFilter !== date_filter_1 || prevState.totalSiData !== si_data)
        ) {
            function subtractDataCounts(data1, data2) {
                return data1.map(item1 => {
                    const item2 = data2.find(item => item.key === item1.key); // Find corresponding item in data2
                    const count2 = item2 ? item2.count : 0; // If not found, default to 0
                    return {
                        key: item1.key,
                        count: item1.count - count2, // Subtract counts
                    };
                });
            }

            const registered_inventory_chart = this.GetRegisteredInventory(data, date_filter, false, false);
            const registered_inventory_chart_1 = this.GetRegisteredInventory(data, 'all', false, false);
            const remaining_inventory_chart = this.GetRegisteredInventory(data, 'all', true, false);

            const assigned_inventory_chart = this.GetRegisteredInventory(data, date_filter, false, true);


            const inventory_mapping = this.getInvetoryMapping(data, this.state.secondChartFilter)
            console.log(inventory_mapping)


            const si_chart = si_data.length > 0 ? this.GetTotalModifiedData(si_data, date_filter) : []
            // console.log(si_chart, si_data);

            // Update state only if the chart data has actually changed
            if (this.state.registered_okas_invetory_chart !== registered_inventory_chart) {
                this.setState({ registered_okas_invetory_chart: registered_inventory_chart });
            }

            if (this.state.registered_okas_invetory_chart_1 !== registered_inventory_chart_1) {
                this.setState({ registered_okas_invetory_chart_1: registered_inventory_chart_1 });
            }

            // Update state only if the chart data has actually changed
            if (this.state.remaining_okas_invetory_chart !== remaining_inventory_chart) {
                this.setState({ remaining_okas_invetory_chart: remaining_inventory_chart });
            }

            if (this.state.assigned_inventory_chart !== assigned_inventory_chart) {
                this.setState({ assigned_inventory_chart: assigned_inventory_chart });
            }

            // Update state only if the chart data has actually changed
            if (this.state.si_chart !== si_chart) {
                this.setState({ si_chart: si_chart });
            }

            // Update state only if the chart data has actually changed
            if (this.state.inventory_mapping !== inventory_mapping) {
                this.setState({ inventory_mapping: inventory_mapping });


            }
            // console.log(this.state.inventory_mapping)


        }
    }








    //this funtion is used to limit the word with it goes after the permissible limit.
    // text is the text we want to apply function on
    // limit is the limit after which we want to extract word from.
    sliceText = (text, limit) => {
        if (text.length < limit) {
            return text
        } else {
            return text.substring(0, limit) + '...'
        }
    }

    handleMouseEnter = (id) => {
        this.setState({ hoveredId: id });
    };

    handleMouseLeave = () => {
        this.setState({ hoveredId: null });
    };


    renderTableData = (type) => {
        if (this.state.okasBoxData.detail == 'Invalid token.') {
            localStorage.removeItem('auth');
            localStorage.removeItem('username');
            window.location.href = '/login'
        }
        let indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
        let indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
        let currentTodos = this.state.totalSiData.slice(indexOfFirstTodo, indexOfLastTodo);
        if (type === 'pagination') {
            let pageNumbers = [];
            for (let i = 1; i <= Math.ceil(this.state.okasBoxData.length / this.state.todosPerPage); i++) {
                pageNumbers.push(i);
            }
            let renderPageNumbers = pageNumbers.map(number => {
                return (
                    <li className={this.state.currentPage == number ? "active" : null}><a id={number} onClick={this.handleClickpage}>{number}</a></li>
                );
            });
            return renderPageNumbers;
        }
        if (type === 'type1') {
            let typee = 0;
            let startIndex = Math.max(0, this.state.okasBoxData.length - 3);
            let xx = this.state.totalSiData.slice(startIndex).map((e, index) => {
                const correspondingSiBoxInventory = this.state.siBoxData[e.si_email];
                const boxNumber = correspondingSiBoxInventory ? correspondingSiBoxInventory : '0';
                typee = typee + 1;
                return (
                    <div className="col-sm-6 col-md-4 col-lg-4 mainthumbnailbig" key={index}>
                        <div
                            className="thumbnail mainthumbnail"
                            style={{ border: 'none', boxShadow: 'none', backgroundColor: '#E1D5C9' }}
                        >
                            <div
                                className="caption maincaption"
                                style={{
                                    height: 'auto',
                                    borderRadius: '20px',
                                    backgroundColor: '#E7E0D9',
                                    boxShadow: '0px 3px 6px #272D3B33',
                                }}
                            >
                                <span className="downloadicon">
                                    <img src={Copy} alt="Copy Icon" />
                                </span>
                                <h3 style={{ fontSize: '21px' }}>{e.si_name}</h3>
                                <p className="p11" style={{ height: '8px' }}>
                                    Location: {this.sliceText(e.si_address, 40)}
                                </p>
                                <p className="p11" style={{ height: '25px' }}>
                                    Details: {this.sliceText(e.si_area, 20)}
                                </p>
                                <p className="p11" style={{ height: '10px' }}>
                                    Inventory: {index + 1}
                                </p>
                                <div
                                    key={e.si_id}
                                    className="arowicon"
                                >

                                    <a href={`/systemintegratoradd?modal2=true&si_id=${e.si_id}`}> <img
                                        src={this.state.hoveredId === e.si_id ? ArrowRight : MoreButton3}
                                        alt="Data Image"
                                        onMouseEnter={() => this.setState({ hoveredId: e.si_id })}
                                        onMouseLeave={() => this.setState({ hoveredId: null })}
                                        style={{
                                            width: '22px',
                                            height: '22px',
                                            transition: 'opacity 1s ease, transform 1s ease', // Add smooth opacity and transform transition
                                            opacity: this.state.hoveredId === e.si_id ? 1 : 0.8, // Change opacity on hover
                                            transform: this.state.hoveredId === e.si_id ? 'scale(1.1)' : 'scale(1)', // Slight scaling effect
                                        }}
                                    /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            });
            return xx;
        }

        else if (type === 'typetable') {
            var typee = 0;
            let startIndex = 0;
            let xx = this.state.totalSiData.slice(startIndex, 5).map((e, index) => {
                const correspondingSiBoxInventory = this.state.siBoxData[e.si_email];

                const boxNumber = correspondingSiBoxInventory ? correspondingSiBoxInventory : '0';
                typee = typee + 1;
                return (
                    <tr key={index}>
                        <td >{e.si_name}</td>
                        <td>{e.si_address}</td>
                        <td>{e.si_area}</td>
                        <td style={{ paddingLeft: '5%' }}>{boxNumber}</td>
                    </tr>
                )
                // }            
            });
            return xx;
        }
        else if (type === 'type2') {
            let xx1 = this.state.okasBoxData.map((e, index) => {
                if (e.okas_box_number === 123) {
                    return (
                        <div className="col-sm-6 col-md-3 mainthumbnailbig" key={index}>
                            <div className="thumbnail mainthumbnail">
                                <div className="caption maincaption">
                                    <img src={Img1} alt="we.okas logo" className="navbar-right" />
                                    <h3>{e.owner_name}</h3>
                                    <p className="p11">D-147, Okhla Industrial Area Phase 1 Delhi-110020</p>
                                    <p className="p12">Project Manager</p>
                                    <p className="p13">Office Location</p>
                                </div>
                                <div>
                                    <h5>No. of OKAS Box - <b>10</b></h5>
                                </div>
                            </div>
                        </div>
                    )
                }
            });
            return xx1;
        }
    }

    formatTime(startDateTime, endDateTime) {
        // Create Date objects for start and end times
        const startDate = new Date(startDateTime);
        const endDate = new Date(endDateTime);

        // Check if the date is "Today"
        const today = new Date();
        const isToday =
            startDate.getDate() === today.getDate() &&
            startDate.getMonth() === today.getMonth() &&
            startDate.getFullYear() === today.getFullYear();

        // Format the start and end times
        const startTime = new Intl.DateTimeFormat('en-US', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
        }).format(startDate);

        const endTime = new Intl.DateTimeFormat('en-US', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
        }).format(endDate);

        // Format the date (show "Today" if the event is today)
        const formattedDate = isToday
            ? "Today"
            : startDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

        // Return the formatted string with parentheses around it
        return `(${formattedDate}, ${startTime} - ${endTime})`;
    }

    predictGrowth = (initialBox, initialPrice, boxGrowth, priceGrowth, initialSubscription) => {
        let predictions = [];
        let currentBoxes = initialBox;
        let currentPrice = initialPrice;
        let currentSubscriptionPrice = initialSubscription;
        let totalSubscribedBoxes = 0;
        let currentYear = new Date().getFullYear();

        for (let i = 0; i < 10; i++) {
            let value = currentBoxes * currentPrice;
            totalSubscribedBoxes += currentBoxes;
            let subscriptionRevenue = totalSubscribedBoxes * currentSubscriptionPrice;
            //   console.log(totalSubscribedBoxes, currentSubscriptionPrice)
            predictions.push({
                name: currentYear + i,
                boxes: Math.round(currentBoxes),
                box_revenue: Math.round(value),
                market_space: Math.round(subscriptionRevenue),
            });

            // Apply growth rates
            currentBoxes *= 1 + boxGrowth / 100;
            currentPrice *= 1 + priceGrowth / 100;
            currentSubscriptionPrice *= 1 + priceGrowth / 100;
        }

        return predictions;
    };

    handleInitialBoxChange = (value) => {
        console.log("this is box change", value, 250000, this.state.growth, 6, 25000)
        this.setState({ initial_box: value })
        const data = this.predictGrowth(value, 250000, this.state.growth, 6, 25000)

        this.setState({ revenue_data: data })
    }

    handleGrowthChange = (value) => {
        console.log("this is growth change", this.state.initial_box, 250000, value, 6, 25000)
        this.setState({ growth: value })
        const data = this.predictGrowth(this.state.initial_box, 250000, value, 6, 25000)
        this.setState({ revenue_data: data })
    }



    render() {

        const videoData = this.state.videoItems.find(video => video.id === this.state.videoId);


        return Style.it(`
                     @media only screen and (max-width: 760px){
                   td:nth-of-type(1):before { content: "SI NAME"; }
                   td:nth-of-type(2):before { content: "ADDRESS"; }
                   td:nth-of-type(3):before { content: "AREA"; }
                   td:nth-of-type(4):before { content: "INVENTORY"; }
        }
          `,
            <div className="container dashboardContainer dashboardContainer-Mobile" style={{ backgroundColor: '#E1D5C9' }} >
                <div className="dashboardLeft">



                    <div
                        className="row">

                        {/* <div className="totalboxcont"> */}

                        <div className="col-md-9" style={{ paddingLeft: '25px', paddingRight: '45px' }}>
                            <div
                                className="assign-buttons"
                                style={{
                                    display: 'flex', // Flex container
                                    flexDirection: 'row', // Align items horizontally
                                    justifyContent: 'flex-end', // Align items to the right (flex end)
                                    alignItems: 'flex-end', // Align items at the bottom
                                    gap: '20px', // Add space between the two items
                                    //border: '1px solid red', // Existing style
                                    padding: '10px', // Optional: Add padding for a cleaner layout
                                    width: '100%'
                                }}
                            >
                                <div
                                    style={{
                                        display: 'block', // Ensure this div wraps both button and span
                                        textAlign: 'center', // Center-align the content inside
                                    }}
                                >

                                    <a href='/okasunassignedbox?modal=true'>
                                        <button
                                            className="assign-inventory-button"
                                            style={{
                                                color: '#393939',
                                                fontWeight: 'bold',
                                                backgroundColor: '#39c0bc',
                                                width: '40px',
                                                height: '40px',
                                                borderRadius: '50%',
                                                fontSize: '24px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                border: 'none',
                                                cursor: 'pointer',
                                                margin: 'auto',
                                                transition: 'background-color 0.3s ease, transform 0.3s ease, color 0.3s ease', // Smooth transitions
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.backgroundColor = '#2fa5a4'; // Darker shade on hover
                                                e.target.style.color = '#fff'; // Change text color to white
                                                e.target.style.transform = 'scale(1.1)'; // Slight zoom effect
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.backgroundColor = '#39c0bc'; // Revert to original background
                                                e.target.style.color = '#393939'; // Revert text color
                                                e.target.style.transform = 'scale(1)'; // Reset scaling
                                            }}
                                        >
                                            +
                                        </button>
                                    </a>

                                    <span
                                        style={{
                                            display: 'block', // Block-level element for span to sit below the button
                                            // font: 'normal normal normal 14px/16px Poppins',
                                            letterSpacing: '0px',
                                            color: '#393939',
                                            opacity: '1',
                                            marginTop: '8px', // Add some space between button and text
                                            fontSize: '12px'
                                        }}
                                    >
                                        Assign Inventory
                                    </span>
                                </div>

                                <div
                                    style={{
                                        display: 'block', // Ensure this div wraps both button and span
                                        textAlign: 'center', // Center-align the content inside
                                    }}
                                >

                                    <a href='/systemintegratoradd?modal=true'>
                                        <button
                                            className="assign-inventory-button"
                                            style={{
                                                color: '#393939',
                                                fontWeight: 'bold',
                                                backgroundColor: '#39c0bc',
                                                width: '40px',
                                                height: '40px',
                                                borderRadius: '50%',
                                                fontSize: '24px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                border: 'none',
                                                cursor: 'pointer',
                                                margin: 'auto',
                                                transition: 'background-color 0.3s ease, transform 0.3s ease, color 0.3s ease', // Smooth transitions
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.backgroundColor = '#2fa5a4'; // Darker shade on hover
                                                e.target.style.color = '#fff'; // Change text color to white
                                                e.target.style.transform = 'scale(1.1)'; // Slight zoom effect
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.backgroundColor = '#39c0bc'; // Revert to original background
                                                e.target.style.color = '#393939'; // Revert text color
                                                e.target.style.transform = 'scale(1)'; // Reset scaling
                                            }}
                                        >
                                            +
                                        </button>
                                    </a>

                                    <a href="projectdetailadd"> <span
                                        style={{
                                            display: 'block', // Block-level element for span to sit below the button
                                            // font: 'normal normal normal 14px/16px Poppins',
                                            letterSpacing: '0px',
                                            color: '#393939',
                                            opacity: '1',
                                            marginTop: '8px', // Add some space between button and text
                                            fontSize: '12px'
                                        }}
                                    >
                                        Add System Integrator
                                    </span></a>
                                </div>
                            </div>

                            <br />
                            <hr
                                style={{
                                    border: 'none',               // Remove default border
                                    borderTop: '5px solid #EE7A2B', // Make the line bold and give it the desired color
                                    width: '8%',
                                    marginBottom: '1rem',
                                    marginLeft: '0',
                                    marginTop: '6rem'
                                }}
                            />
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '5%'
                            }}>
                                <h3 style={{
                                    textAlign: 'left',
                                    letterSpacing: '0px',
                                    color: '#272D3B',
                                    opacity: '0.5',
                                    fontWeight: '700',
                                    fontSize: '20px',
                                    margin: '0'


                                }}>
                                    Status
                                </h3>

                                <select
                                    style={{
                                        padding: '5px 20px',
                                        fontSize: '12px',
                                        fontWeight: '500',
                                        color: '#97A3B5',
                                        border: '1px solid #97A3B5',
                                        backgroundColor: 'transparent',
                                        borderRadius: '20px',
                                        backgroundImage: `url(${nonu})`, // Use the imported SVG
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: '10px center', // Adjust position
                                        backgroundSize: '16px 16px', // Size of the SVG
                                        paddingLeft: '30px', // Space for the icon
                                        outline: 'none',
                                    }}
                                    onChange={(e) => this.setState({ firstChartFilter: e.target.value })} // Replace with your sorting logic
                                >
                                    <option value="all">All</option>
                                    <option value="lastMonth">Last Month</option>

                                    {/* <option value="all">All</option> */}
                                </select>
                            </div>
                            <div className="row ">
                                <div className="col-md-4 col-sm-4">
                                    <a href={this.state.firstChartFilter === "all" ? `assignokasbox?type=total` : `assignokasbox?filter=${this.state.firstChartFilter}&type=total`}>
                                        <div className="totalboxcont1 totalboxcount1middel2">
                                            <div className="totalboxcont11">
                                                <b>TOTAL ORDERED INVENTORY </b>
                                                <p>Total inventory boxes registered in the system</p>
                                            </div>
                                            <div className="totalboxcont12" style={{
                                                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.8)", // Horizontal, vertical, blur, and color
                                            }}>
                                                {this.CalculateSum(this.state.registered_okas_invetory_chart)}
                                                {console.log(this.state.registered_okas_invetory_chart)}
                                            </div>

                                            <ResponsiveContainer width="100%" height={140}>
                                                <AreaChart
                                                    width={200}
                                                    data={(this.state.registered_okas_invetory_chart.length === 0 || this.state.registered_okas_invetory_chart.length === 1) ? [{ count: 5 }, { count: 5 }] : this.state.registered_okas_invetory_chart.map((e => { return { ...e, count: e.count + 5 } }))}
                                                    margin={{
                                                        top: 5,
                                                        right: 0,
                                                        left: 0,
                                                        bottom: 0,
                                                    }}
                                                >
                                                    <Area type="monotone" dataKey="count" stroke="#55B9C4" fill="#55B9C4" />
                                                </AreaChart>
                                            </ResponsiveContainer>

                                        </div>
                                    </a>
                                </div>


                                <div className="col-md-4 col-sm-4">
                                    <a href="okasunassignedbox">
                                        <div className="totalboxcont1 totalboxcount1middel2" style={{ position: 'relative' }}>
                                            <div className="totalboxcont11">
                                                <b>INVENTORY IN STORE </b>
                                                <p>Total inventory currently available in stock.</p>
                                            </div>
                                            <div className="totalboxcont12" style={{
                                                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.8)", // Horizontal, vertical, blur, and color
                                            }}>
                                                {this.state.okasBoxDataUnassign.length}
                                            </div>

                                            <ResponsiveContainer width="100%" height={140}>
                                                <AreaChart
                                                    width={200}
                                                    data={(this.state.registered_okas_invetory_chart_1.length === 0 || this.state.registered_okas_invetory_chart_1.length === 1) ? [{ count: 5 }, { count: 5 }] : this.state.registered_okas_invetory_chart_1.map((e => { return { ...e, count: e.count + 5 } }))}
                                                    margin={{
                                                        top: 5,
                                                        right: 0,
                                                        left: 0,
                                                        bottom: 0,
                                                    }}
                                                >
                                                    <Area type="monotone" dataKey="count" stroke="#55B9C4" fill="#55B9C4" />
                                                </AreaChart>
                                            </ResponsiveContainer>
                                            <div style={{ position: 'absolute', width: '100%', bottom: '0px' }}>
                                                <ResponsiveContainer width="100%" height={140} >
                                                    <AreaChart
                                                        width={200}

                                                        // height={60}
                                                        data={(this.state.remaining_okas_invetory_chart.length === 0 || this.state.remaining_okas_invetory_chart.length === 1) ? [{ count: 5 }, { count: 5 }] : this.state.remaining_okas_invetory_chart.map((e => { return { ...e, count: e.count + 5 } }))}
                                                        margin={{
                                                            top: 5,
                                                            right: 0,
                                                            left: 0,
                                                            bottom: 0,
                                                        }}
                                                    >
                                                        <Area type="monotone" dataKey="count" stroke="#48D7F8" fill="#48D7F8" />
                                                    </AreaChart>
                                                </ResponsiveContainer>
                                            </div>

                                        </div>
                                    </a>
                                </div>

                                <div className="col-md-4 col-sm-4">
                                    {/* <a href="systemintegratoradd"> */}
                                    <a href={this.state.firstChartFilter === "all" ? `assignokasbox?type=assigned` : `assignokasbox?filter=${this.state.firstChartFilter}&type=assigned`}>

                                        <div className="totalboxcont1 totalboxcount1middel2">
                                            <div className="totalboxcont11">
                                                <b>INVENTORY ASSIGNED</b>
                                                <p>Total inventory assigned to system integrators.</p>
                                            </div>
                                            <div className="totalboxcont12" style={{
                                                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.8)", // Horizontal, vertical, blur, and color
                                            }}>

                                                {this.CalculateSum(this.state.assigned_inventory_chart)}
                                            </div>
                                            {/* Area Chart Integration */}
                                            <ResponsiveContainer width="100%" height={140}>
                                                <AreaChart
                                                    width={200}
                                                    // height={60}
                                                    data={(this.state.assigned_inventory_chart.length === 0 || this.state.assigned_inventory_chart.length === 1) ? [{ count: 5 }, { count: 5 }] : this.state.assigned_inventory_chart.map((e => { return { ...e, count: e.count + 5 } }))}
                                                    margin={{
                                                        top: 5,
                                                        right: 0,
                                                        left: 0,
                                                        bottom: 0,
                                                    }}
                                                >
                                                    <Area type="monotone" dataKey="count" stroke="#55B9C4" fill="#55B9C4" />
                                                </AreaChart>
                                            </ResponsiveContainer>
                                            {/* </div> */}
                                        </div>
                                    </a>
                                </div>
                            </div>

                            {/* need to add here */}

                            <hr
                                style={{
                                    border: 'none',               // Remove default border
                                    borderTop: '5px solid #EE7A2B', // Make the line bold and give it the desired color
                                    width: '8%',
                                    marginBottom: '1rem',
                                    marginLeft: '0',
                                    marginTop: '6rem'
                                }}
                            />

                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '5%',
                                // border: '1px solid red'
                            }}>

                                <h3 style={{
                                    textAlign: 'left',
                                    letterSpacing: '0px',
                                    color: '#272D3B',
                                    opacity: '0.5',
                                    fontWeight: '700',
                                    fontSize: '20px',
                                    margin: '0'
                                }}>
                                    Revenue Potential & Business Growth Projection
                                </h3>

                            </div>
                            <div style={{
                                backgroundColor: "#FFFFFF",
                                padding: "3rem",
                                position: "relative", // To allow positioning of the text on the left
                            }}>

                                {/* Left-hand side vertical text */}
                                <div style={{
                                    position: "absolute",
                                    left: "10px", // Adjust for positioning
                                    bottom: "190px", // Adjust for positioning
                                    writingMode: "vertical-rl", // Rotates text bottom to top
                                    transform: "rotate(180deg)", // Makes text face correctly
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                    color: "#333333",
                                }}>
                                    Revenue Growth ($)
                                </div>



                                <ResponsiveContainer width={"100%"} height={300}>
                                    <LineChart
                                        width={500}
                                        height={300}
                                        data={this.state.revenue_data}
                                        margin={{
                                            top: 5,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                        }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="name" tick={{ fontSize: 10 }} // ✅ set font size here
                                        />
                                        <YAxis tickFormatter={(value) => {
                                            if (value >= 10000000) {
                                                return `$${(value / 10000000).toFixed(2)}Cr`;
                                            } else if (value >= 100000) {
                                                return `$${(value / 100000).toFixed(2)}L`;
                                            } else {
                                                return `$${value}`;
                                            }
                                        }} tick={{ fontSize: 10 }} // ✅ set font size here
                                        />
                                        <Tooltip formatter={(value) => {
                                            if (value >= 10000000) {
                                                return `$${(value / 10000000).toFixed(2)}Cr`;
                                            } else if (value >= 100000) {
                                                return `$${(value / 100000).toFixed(2)}L`;
                                            } else {
                                                return `$${value}`;
                                            }
                                        }} />
                                        <Legend />
                                        <Line type="monotone" dataKey="market_space" name={"Market Place"} stroke="#8884d8" activeDot={{ r: 8 }} />
                                        <Line type="monotone" dataKey="box_revenue" name={"Box Revenue"} stroke="#82ca9d" />
                                    </LineChart>
                                </ResponsiveContainer>
                                <div >
                                    <div >
                                        <div>
                                            <label htmlFor="initial_box" style={{ color: '#333333' }}>First-Year Sales Projection – OKAS Master Studio</label>
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                <input
                                                    type="range"
                                                    id="initial_box"
                                                    min="0"
                                                    max="200"
                                                    value={this.state.initial_box}
                                                    onChange={(e) => this.handleInitialBoxChange(Number(e.target.value))}
                                                    className="w-64"
                                                />
                                                <span className="text-xl font-bold">{this.state.initial_box}</span>
                                            </div>
                                        </div>

                                        <div>
                                            <div>
                                                <label htmlFor="growth" style={{ color: '#333333' }}>Annual Growth Rate (%)</label>
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    <input
                                                        type="range"
                                                        id="growth"
                                                        min="0"
                                                        max="200"
                                                        value={this.state.growth}
                                                        onChange={(e) => this.handleGrowthChange(Number(e.target.value))}
                                                        className="w-64"
                                                    />
                                                    <span className="text-xl font-bold">{this.state.growth}%</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <hr
                                style={{
                                    border: 'none',               // Remove default border
                                    borderTop: '5px solid #EE7A2B', // Make the line bold and give it the desired color
                                    width: '8%',
                                    marginBottom: '1rem',
                                    marginLeft: '0',
                                    marginTop: '6rem'
                                }}
                            />
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '5%',
                                // border: '1px solid red'
                            }}>
                                <h3 style={{
                                    textAlign: 'left',
                                    letterSpacing: '0px',
                                    color: '#272D3B',
                                    opacity: '0.5',
                                    fontWeight: '700',
                                    fontSize: '20px',
                                    margin: '0'
                                }}>
                                    OKAS Inventory Over Time
                                </h3>
                                <select
                                    style={{
                                        padding: '5px 20px',
                                        fontSize: '12px',
                                        fontWeight: '500',
                                        color: '#97A3B5',
                                        border: '1px solid #97A3B5',
                                        // marginTop: '3%',
                                        backgroundColor: 'transparent',
                                        borderRadius: '20px',
                                        // appearance: 'none', // Removes default arrow
                                        backgroundImage: `url(${nonu})`, // Use the imported SVG
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: '10px center', // Adjust position
                                        backgroundSize: '16px 16px', // Size of the SVG
                                        paddingLeft: '30px', // Space for the icon
                                        outline: 'none',
                                    }}
                                    onChange={(e) => this.setState({ secondChartFilter: e.target.value })} // Replace with your sorting logic
                                >
                                    <option value="all">All</option>
                                    <option value="lastYear">Last Year</option>
                                    <option value="lastMonth">Last Month</option>
                                </select>
                            </div>


                            <div style={{
                                backgroundColor: "#FFFFFF",
                                height: "400px",
                                display: "flex", // Enables Flexbox
                                justifyContent: "center", // Centers content horizontally
                                alignItems: "center", // Centers content vertically
                                position: "relative", // To allow positioning of the text on the left
                            }}>
                                {/* Left-hand side vertical text */}
                                <div style={{
                                    position: "absolute",
                                    left: "10px", // Adjust this value to position the text properly
                                    bottom: "80px", // You can adjust this too to fine-tune the positioning
                                    writingMode: "vertical-rl", // Rotates the text from bottom to top
                                    transform: "rotate(180deg)", // Makes sure text faces the correct direction
                                    fontSize: "12px", // Adjust the font size as needed
                                    fontWeight: "bold", // Optional: Makes the text bold
                                    color: "#333333", // Optional: Set the text color
                                }}>
                                    {/* Number of OKAS Inventory */}
                                    Number of Okas Boxes in Inventory
                                </div>

                                {/* Bottom horizontal text */}
                                <div style={{
                                    position: "absolute",
                                    bottom: "10px",
                                    left: this.state.secondChartFilter === "all" ? "21%" :
                                        this.state.secondChartFilter === "lastYear" ? "22%" : "22%",
                                    transform: "translateX(-50%)",
                                    fontSize: "13px",
                                    fontWeight: "bold",
                                    color: "#333333",
                                }}>
                                    {this.state.secondChartFilter === "all" ? "Year of Inventory Orders" :
                                        this.state.secondChartFilter === "lastYear" ? "Last Year of Inventory Orders" :
                                            "Last Month of Inventory Orders"}
                                </div>
                                <ResponsiveContainer width={"100%"} height={300}>

                                    <BarChart
                                        data={this.state.inventory_mapping}
                                        barSize={20} // Sets the width of all bars
                                        margin={{
                                            top: 20,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,

                                        }}
                                    >
                                        <CartesianGrid horizontal={true} vertical={false} strokeDasharray="3 3" stroke="#ddd" />


                                        <YAxis
                                            tickFormatter={(tick) => {
                                                if (tick >= 1000000) {
                                                    return `${(tick / 1000000).toFixed(1)}M`;  // Converts large numbers to millions (M)
                                                } else if (tick >= 1000) {
                                                    return `${(tick / 1000).toFixed(1)}K`;  // Converts to thousands (K)
                                                }
                                                return tick;  // For smaller numbers, just return as is
                                            }} tick={{ fontSize: 10 }}
                                        />
                                        <XAxis dataKey={this.state.secondChartFilter === "currentMonth" ? "none" : "key"} tick={{ fontSize: 10 }} />

                                        <Tooltip content={<CustomTooltip />} />
                                        <Legend
                                            iconType="circle"   // Makes the icon circular
                                            iconSize={12}        // Adjust the size of the circle
                                            layout="horizontal"  // Horizontal legend layout
                                            align="right"        // Align the legend to the right
                                            verticalAlign="top"  // Align the legend to the top
                                            wrapperStyle={{
                                                position: 'absolute',
                                                top: '10px',        // Adjust as needed
                                                right: '10px',      // Adjust as needed
                                                padding: '10px',
                                            }}

                                        />
                                        <Bar dataKey="assigned" name="Inventory in Project" stackId="a" fill="#F49E59" background={{ fill: '#E6F3FF' }} />
                                        <Bar dataKey="unassigned" name=" Inventory Assigne" stackId="a" fill="#ECCFA9" />
                                    </BarChart>
                                </ResponsiveContainer>
                            </div>
                            {/* <br/> */}
                            <div className="row conwidth totalboxcount1left" style={{ backgroundColor: '#E1D5C9' }}>
                                <div className="totalboxcont111 ">
                                    {/* <b>RECENTLY ADDED</b> */}
                                    <br />
                                    {/* <span> PROJECT</span> */}
                                    <hr
                                        style={{
                                            border: 'none',               // Remove default border
                                            borderTop: '5px solid #EE7A2B', // Make the line bold and give it the desired color
                                            width: '8%',
                                            marginBottom: '1rem',
                                            marginLeft: '0',
                                            marginTop: '4rem'
                                        }}
                                    />

                                    <h3 style={{
                                        textAlign: 'left',
                                        letterSpacing: '0px',
                                        color: '#272D3B',
                                        opacity: '0.5',
                                        fontWeight: '700',
                                        fontSize: '20px',
                                        margin: '0'

                                    }}>Recently Added System Integrator</h3>
                                </div>
                                <div className="listgridbutton">
                                    {this.state.hideGridView ?
                                        <span>
                                            <span className=""><img src={GridViewBlue} /></span>  <a onClick={(e) => {
                                                this.setState({
                                                    hideGridView: !this.state.hideGridView
                                                })
                                            }} ><span className="iconnotactive"><img src={ListViewGray} /></span></a>

                                        </span>

                                        :
                                        <span>
                                            <a onClick={(e) => {
                                                this.setState({
                                                    hideGridView: !this.state.hideGridView
                                                })
                                            }}

                                            ><span className="iconnotactive"><img src={GridViewGray} /></span></a>
                                            <span className=""> <img src={ListViewBlue} /></span>
                                        </span>

                                    }
                                </div>
                                {this.state.hideGridView ?
                                    <div className="row ">
                                        {
                                            this.renderTableData('type1').length
                                                ?
                                                this.renderTableData('type1').slice(0, 3)
                                                :
                                                <span className="mainthumbnailbig">
                                                    <img src={scope} className="scopeimage1" />
                                                    <p className="scopeline text-center">Note that it can not be centered if the width is set to 100% (full-width).</p>
                                                    <span className=" text-center"><a href="/systemintegratoradd" className="btn scopebutton1">Add Systemintegrator</a></span>
                                                </span>

                                        } </div>
                                    :
                                    <div onResize className=" mainthumbnailbig12 tests12 mobile-device-padding-zero" >
                                        {this.renderTableData('typetable').length
                                            ?
                                            <TableContainer component={Paper} className={this.props.windowWidth > 760 ? "table custom-striped-table-dashboard dashboardtablemain" : ""}>
                                                <Table className={"tablecontent"} sx={{ backgroundColor: "#f0f0f0 !important" }}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell sx={{ width: this.props.windowWidth > 835 ? "15%" : "20%", color: "white", fontSize: '11px' }}>SI NAME</TableCell>
                                                            <TableCell sx={{ width: this.props.windowWidth > 835 ? "15%" : "20%", color: "white", fontSize: '11px' }}>ADDRESS</TableCell>
                                                            <TableCell sx={{ width: this.props.windowWidth > 835 ? "15%" : "20%", color: "white", fontSize: '11px' }}>AREA</TableCell>
                                                            <TableCell sx={{ width: this.props.windowWidth > 835 ? "15%" : "20%", color: "white", fontSize: '11px' }}>INVENTORY</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {this.renderTableData('typetable')}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                            :
                                            <span>
                                                <img src={scope} className="scopeimage2" />
                                                <p className="scopeline text-center">Note that it can not be centered if the width is set to 100% (full-width).</p>
                                                <span className=" text-center"><a href="/systemintegratoradd" className="btn scopebutton">Add SI</a></span>
                                            </span>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="col-md-3 totalboxcount1right" style={{ padding: "0px" }}>

                            <div className='knowledge-bank' style={{
                                borderRadius: '15px', backgroundColor: '#d1d5d6',
                                boxShadow: '0px 3px 6px #272D3B33',

                            }}>
                                <h4 style={{
                                    textAlign: 'left',
                                    font: 'normal normal bold 20px/30px Montserrat',
                                    letterSpacing: '0px',
                                    color: '#000000',
                                    opacity: '1',
                                    padding: '10px',
                                    marginLeft: '10px',
                                    fontFamily: ' proxima-nova, sans-serif',

                                }}>Knowledge Bank</h4>

                                {this.state.knowledgeBank.slice(0, 4).map((item, index) => (
                                    <a
                                        href={item.pdf}
                                        key={index}
                                        className='hover-effect'
                                        style={{
                                            color: 'inherit', textDecoration: 'none',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px',
                                            marginLeft: '15px',
                                            marginBottom: "10px"
                                        }}
                                    >
                                        <img
                                            src={Download1} // Path to the image
                                            alt="Data Image"
                                            style={{
                                                width: '22px', // Adjust size as needed
                                                height: '22px',

                                            }}
                                        />
                                        <div style={{ display: 'block' }}>
                                            <span style={{ width: '100%', display: 'block', fontSize: '16px' }}>{item.title}</span>
                                            <a href={item.pdf} style={{ display: 'block', color: 'inherit', textDecoration: 'none' }}><span style={{ width: '80%', fontSize: '12px' }}>( Download Now )</span></a>
                                        </div>

                                    </a>
                                ))}
                                <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px' }}>
                                    <a href="/knowledgeBank" style={{ display: 'flex', alignItems: 'center' }}>
                                        <img
                                            src={MoreButton} // Path to the image
                                            alt="Data Image"
                                            style={{
                                                width: '22px', // Adjust size as needed
                                                height: '22px',

                                            }}
                                        />
                                    </a>
                                </div>


                            </div>
                            {
                                this.state.upcommingEvents.length > 0 && <div className='upcoming-events' style={{
                                    borderRadius: '15px', backgroundColor: '#d2e1dc',
                                    boxShadow: '0px 3px 6px #272D3B33', marginTop: '7%'
                                }}>
                                    <h4 style={{
                                        textAlign: 'left',
                                        font: 'normal normal bold 20px/30px Montserrat',
                                        letterSpacing: '0px',
                                        color: '#000000',
                                        opacity: '1',
                                        padding: '10px',
                                        marginLeft: '10px',
                                        fontFamily: ' proxima-nova, sans-serif',

                                    }}>Upcoming Events</h4>

                                    {this.state.upcommingEvents.slice(0, 4).map((item, index) => (
                                        <a
                                            href={item.cta}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ textDecoration: 'none', color: 'inherit' }}>
                                            <p
                                                key={index}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '10px',
                                                    marginLeft: '15px',
                                                }}
                                            >
                                                <img
                                                    src={Group} // Path to the image
                                                    alt="Data Image"
                                                    style={{
                                                        width: '22px', // Adjust size as needed
                                                        height: '22px',

                                                    }}
                                                />
                                                <div style={{ display: 'block' }}>
                                                    <span style={{ width: '100%', display: 'block', fontSize: '16px' }}>{item.title}</span>
                                                    <span style={{ width: '100%', fontSize: '12px', display: 'block', }}>{this.formatTime(item.start_time, item.end_time)}</span>
                                                </div>

                                            </p>
                                        </a>
                                    ))}
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px' }}>
                                        <a href="/upcommingevents" style={{ display: 'flex', alignItems: 'center' }}>
                                            <img
                                                src={MoreButton2} // Path to the image
                                                alt="Data Image"
                                                style={{
                                                    width: '22px', // Adjust size as needed
                                                    height: '22px',

                                                }}
                                            />
                                        </a>
                                    </div>


                                </div>
                            }

                            <div className='Vedios' style={{
                                borderRadius: '15px', backgroundColor: '#edcfa9',
                                boxShadow: '0px 3px 6px #272D3B33', marginTop: '7%'

                            }}>
                                <h4 style={{
                                    textAlign: 'left',
                                    font: 'normal normal bold 20px/30px Montserrat',
                                    letterSpacing: '0px',
                                    color: '#000000',
                                    opacity: '1',
                                    padding: '10px',
                                    marginLeft: '10px',
                                    fontFamily: ' proxima-nova, sans-serif',


                                }}>Video</h4>

                                {this.state.videoItems.slice(0, 4).map((item, index) => (
                                    <a
                                        onClick={() => this.openModal(item.id)}
                                        key={index}
                                        className='hover-effect'
                                        style={{
                                            color: 'inherit', textDecoration: 'none',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px',
                                            marginLeft: '15px',
                                            marginBottom: "10px"
                                        }}
                                    >
                                        <img
                                            src={PlaySecond} // Path to the image
                                            alt="Data Image"
                                            style={{
                                                width: '22px', // Adjust size as needed
                                                height: '22px',

                                            }}
                                        />
                                        <div style={{ display: 'block', width: '100%' }}>
                                            <span style={{ width: '90%', display: 'block', fontSize: '16px' }}>{item.title}</span>

                                        </div>

                                    </a>
                                ))}
                                <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px' }}>
                                    <a href="/video" style={{ display: 'flex', alignItems: 'center' }}>
                                        <img
                                            src={MoreButton3} // Path to the image
                                            alt="Data Image"
                                            style={{
                                                width: '22px', // Adjust size as needed
                                                height: '22px',

                                            }}
                                        />
                                    </a>
                                </div>


                            </div>

                            <div className='whats-New' style={{
                                borderRadius: '15px', backgroundColor: '#cfd3b8',
                                boxShadow: '0px 3px 6px #272D3B33', marginTop: '7%'

                            }}>
                                <h4 style={{
                                    textAlign: 'left',
                                    font: 'normal normal bold 20px/30px Montserrat',
                                    letterSpacing: '0px',
                                    color: '#000000',
                                    opacity: '1',
                                    padding: '10px',
                                    marginLeft: '10px',
                                    fontFamily: ' proxima-nova, sans-serif',

                                }}>What’s New</h4>

                                {this.state.whatsNew.slice(0, 4).map((item, index) => (
                                    <p
                                        key={index}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px',
                                            marginLeft: '15px',

                                        }}
                                    >
                                        <span
                                            style={{
                                                width: '20px', // Adjust size as needed
                                                height: '20px',
                                                borderRadius: '50%', // Makes the image rounded
                                                backgroundColor: '#8CBA7D', // Background color for the image
                                                padding: '5px', // Adds padding inside the rounded background


                                            }}
                                        ></span>
                                        <span style={{ width: '70%', fontSize: '16px' }}>{item.title}</span>

                                    </p>
                                ))}

                                <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px' }}>
                                    <a href="/whatsnew" style={{ display: 'flex', alignItems: 'center' }}>
                                        <img
                                            src={MoreButton4} // Path to the image
                                            alt="Data Image"
                                            style={{
                                                width: '22px', // Adjust size as needed
                                                height: '22px',

                                            }}
                                        />
                                    </a>
                                </div>

                                {this.state.isModalOpen && (
                                    <div
                                        className="modal"
                                        id="hometheaterbox"
                                        role="dialog"
                                        style={{
                                            position: 'fixed',

                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent overlay
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            zIndex: 1000, // Make sure it's above other content
                                        }}
                                    >
                                        <div
                                            className="modal-dialog"

                                        >
                                            <div className="modal-content">
                                                <div className="modal-header" style={{ display: 'flex', justifyContent: 'right', alignItems: 'center', padding: '0px' }}>
                                                    <div style={{ justifyContent: 'space-between', width: '100%', display: 'flex' }}>

                                                        <h4 style={{ marginLeft: '0%' }}>{this.state.videoItems.find(video => video.id === this.state.videoId).title}</h4>
                                                        <button type="button" className="close" data-dismiss="modal" onClick={this.closeModal}>&times;</button>
                                                    </div>
                                                </div>

                                                <div className="modal-body" style={{ padding: '0px 5px', marginTop: '11px' }}>

                                                    {videoData.yt_video ? (
                                                        // <iframe
                                                        //     width="100%"
                                                        //     height="315"
                                                        //     src={`https://www.youtube.com/embed/${videoData.yt_video.split("v=")[1]}`}
                                                        //     title={videoData.title || "YouTube video player"}
                                                        //     frameBorder="0"
                                                        //     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                        //     referrerPolicy="strict-origin-when-cross-origin"
                                                        //     allowFullScreen
                                                        //     style={{ borderRadius: "5px" }}
                                                        // ></iframe>
                                                        <iframe
                                                            width="100%"
                                                            height="315"
                                                            src={(() => {
                                                                try {
                                                                    const url = new URL(videoData.yt_video); // Create URL object from the yt_video string
                                                                    // console.log("Processing YouTube URL:", videoData.yt_video); // Log the YouTube URL

                                                                    if (url.hostname.includes('youtu.be')) {
                                                                        // For short URLs like https://youtu.be/VIDEO_ID
                                                                        const videoID = url.pathname.slice(1); // Extract video ID from the pathname
                                                                        // console.log("Shortened YouTube URL detected. Video ID:", videoID); // Log the extracted video ID
                                                                        return `https://www.youtube.com/embed/${videoID}`; // Return embedded URL
                                                                    } else if (url.hostname.includes('youtube.com')) {
                                                                        // For regular YouTube URLs like https://www.youtube.com/watch?v=VIDEO_ID
                                                                        const videoID = url.searchParams.get('v'); // Extract video ID from the query parameter
                                                                        // console.log("Regular YouTube URL detected. Video ID:", videoID); // Log the extracted video ID
                                                                        return `https://www.youtube.com/embed/${videoID}`; // Return embedded URL
                                                                    } else {
                                                                        //  console.error("Invalid YouTube URL format:", videoData.yt_video); // Log invalid YouTube URLs
                                                                        return ''; // Return an empty string if it's not a valid YouTube URL
                                                                    }
                                                                } catch (error) {
                                                                    console.error("Error processing YouTube URL:", error); // Log any errors encountered
                                                                    return ''; // Return an empty string if URL parsing fails
                                                                }
                                                            })()}
                                                            title={videoData.title || "YouTube video player"}
                                                            frameBorder="0"
                                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                            referrerPolicy="strict-origin-when-cross-origin"
                                                            allowFullScreen
                                                            style={{ borderRadius: "5px" }}
                                                        ></iframe>
                                                    ) : videoData.video ? (
                                                        // Render MP4 Video if video field is present
                                                        <video
                                                            width="100%"
                                                            height="315"
                                                            controls
                                                            autoPlay
                                                            src={videoData.video}
                                                            style={{ maxWidth: "100%", borderRadius: "5px", margin: "0" }}
                                                        >
                                                            Your browser does not support the video tag.
                                                        </video>
                                                    ) : (
                                                        // Fallback for missing video data
                                                        <p style={{ color: "red", textAlign: "center" }}>
                                                            No video available.
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {/* Whats New POP UP */}
                                {this.state.isModalOpen2 && (
                                    <div
                                        className="modal"
                                        id="hometheaterbox"
                                        role="dialog"
                                        style={{
                                            position: 'fixed',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent overlay
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            zIndex: 1000, // Ensure it's above other content
                                        }}
                                    >
                                        <div className="modal-dialog">
                                            <div className="modal-content">
                                                <div
                                                    className="modal-header"
                                                    style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
                                                >
                                                    <button
                                                        type="button"
                                                        className="close"
                                                        data-dismiss="modal"
                                                        onClick={this.closeModal2}
                                                    >
                                                        &times;
                                                    </button>
                                                </div>
                                                {/* Title Rendering */}
                                                <div className="modal-title">
                                                    {(() => {
                                                        const selectedWhatsNew = this.state.whatsNew.find(
                                                            whatsnew => whatsnew.id === this.state.whatsNewId
                                                        );
                                                        // console.log("Selected whatsNew Item:", selectedWhatsNew);

                                                        return selectedWhatsNew ? (
                                                            <h3 style={{ marginLeft: '5%', textAlign: 'start' }}>
                                                                {selectedWhatsNew.title}
                                                            </h3>
                                                        ) : (
                                                            <p style={{ marginLeft: '5%', color: 'red', textAlign: 'start' }}>
                                                                No title available.
                                                            </p>
                                                        );
                                                    })()}
                                                </div>

                                                {/* Body Content */}
                                                <div className="modal-body" style={{ padding: '20px' }}>
                                                    {(() => {
                                                        const selectedWhatsNew = this.state.whatsNew.find(
                                                            whatsnew => whatsnew.id === this.state.whatsNewId
                                                        );
                                                        return selectedWhatsNew ? (
                                                            <p>{selectedWhatsNew.description}</p>
                                                        ) : (
                                                            <p style={{ color: 'red', textAlign: 'center' }}>
                                                                No description available.
                                                            </p>
                                                        );
                                                    })()}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}



                                {/* Whats New POP UP End*/}

                            </div>
                            <h4 style={{
                                textAlign: 'left',
                                font: 'normal normal bold 20px/30px Montserrat',
                                letterSpacing: '0px',
                                color: 'black',
                                opacity: '1',
                                marginLeft: '8px',
                                fontFamily: ' proxima-nova, sans-serif',

                            }}>Download OKAS Pro</h4>

                            <a href='https://apps.apple.com/us/app/okas-experience-for-iphone/id1498727475' target="_blank" rel="noopener noreferrer" style={{
                                display: 'flex', padding: "10px 15px", alignItems: 'center', gap: '10px', borderRadius: '15px', backgroundColor: '#18162F',
                                boxShadow: '0px 3px 6px #272D3B33', marginBottom: "10px"
                            }}>
                                <img
                                    src={Apple} // Path to the image
                                    alt="Data Image"
                                    style={{
                                        width: '22px', // Adjust size as needed
                                        height: '22px',

                                    }}
                                />
                                <span style={{ color: 'white', fontSize: '16px' }}>for IoS</span>
                            </a>
                            {/* <div rel="noopener noreferrer" style={{
                                display: 'flex', padding: "10px 15px", alignItems: 'center', gap: '10px', borderRadius: '15px', backgroundColor: '#18162F',
                                boxShadow: '0px 3px 6px #272D3B33', marginBottom: "10px"
                            }}>
                                <img
                                    src={Android} // Path to the image
                                    alt="Data Image"
                                    style={{
                                        width: '22px', // Adjust size as needed
                                        height: '22px',

                                    }}
                                />
                                <span style={{ color: 'white', fontSize: '16px' }}>for Android</span>
                            </div> */}
                            <div
                                rel="noopener noreferrer"
                                data-tooltip="Coming soon"
                                style={{
                                    display: 'flex',
                                    padding: "10px 15px",
                                    alignItems: 'center',
                                    gap: '10px',
                                    borderRadius: '15px',
                                    backgroundColor: '#18162F',
                                    boxShadow: '0px 3px 6px #272D3B33',
                                    marginBottom: "10px",
                                    position: 'relative',
                                    cursor: 'not-allowed'
                                }}
                                onMouseEnter={(e) => {
                                    const tooltip = document.createElement('div');
                                    tooltip.textContent = e.currentTarget.getAttribute('data-tooltip');
                                    Object.assign(tooltip.style, {
                                        position: 'absolute',
                                        top: '-35px',
                                        left: '0',
                                        backgroundColor: 'rgba(0, 0, 0, 0.85)',
                                        color: '#fff',
                                        padding: '6px 10px',
                                        borderRadius: '5px',
                                        fontSize: '12px',
                                        whiteSpace: 'nowrap',
                                        zIndex: 1000,
                                        pointerEvents: 'none',
                                        opacity: 1,
                                        boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.3)',
                                    });
                                    tooltip.className = 'custom-tooltip';
                                    e.currentTarget.appendChild(tooltip);
                                }}
                                onMouseLeave={(e) => {
                                    const tooltip = e.currentTarget.querySelector('.custom-tooltip');
                                    if (tooltip) {
                                        e.currentTarget.removeChild(tooltip);
                                    }
                                }}
                            >
                                <img
                                    src={Android} // Path to the image
                                    alt="Data Image"
                                    style={{
                                        width: '22px',
                                        height: '22px',
                                    }}
                                />
                                <span style={{ color: 'white', fontSize: '16px' }}>for Android</span>
                            </div>

                            {/* </a> */}
                            <h4 style={{
                                textAlign: 'left',
                                font: 'normal normal bold 20px/30px Montserrat',
                                letterSpacing: '0px',
                                color: 'black',
                                opacity: '1',

                                marginTop: '15px',
                                marginLeft: '8px',
                                fontFamily: ' proxima-nova, sans-serif',

                            }}>Download OKAS Demo Application</h4>

                            <a href='https://apps.apple.com/us/app/okas-experience-for-iphone/id1498727475' target="_blank" rel="noopener noreferrer" style={{
                                display: 'flex', padding: "10px 15px", alignItems: 'center', gap: '10px', borderRadius: '15px', backgroundColor: '#898989',
                                boxShadow: '0px 3px 6px #272D3B33', marginBottom: "10px"
                            }}>
                                <img
                                    src={Apple} // Path to the image
                                    alt="Data Image"
                                    style={{
                                        width: '22px', // Adjust size as needed
                                        height: '22px',

                                    }}
                                />
                                <span style={{ color: 'white', fontSize: '16px' }}>for IoS</span>
                            </a>
                            {/* <div rel="noopener noreferrer" style={{
                                display: 'flex', padding: "10px 15px", alignItems: 'center', gap: '10px', borderRadius: '15px', backgroundColor: '#898989',
                                boxShadow: '0px 3px 6px #272D3B33', marginBottom: "10px"
                            }}>
                                <img
                                    src={Android} // Path to the image
                                    alt="Data Image"
                                    style={{
                                        width: '22px', // Adjust size as needed
                                        height: '22px',

                                    }}
                                />
                                <span style={{ color: 'white', fontSize: '16px' }}>for Android</span>
                            </div> */}
                            <div
                                rel="noopener noreferrer"
                                data-tooltip="Coming soon"
                                style={{
                                    display: 'flex',
                                    padding: "10px 15px",
                                    alignItems: 'center',
                                    gap: '10px',
                                    borderRadius: '15px',
                                    backgroundColor: '#898989',
                                    boxShadow: '0px 3px 6px #272D3B33',
                                    marginBottom: "10px",
                                    position: 'relative',
                                    cursor: 'not-allowed'
                                }}
                                onMouseEnter={(e) => {
                                    const tooltip = document.createElement('div');
                                    tooltip.textContent = e.currentTarget.getAttribute('data-tooltip');
                                    Object.assign(tooltip.style, {
                                        position: 'absolute',
                                        top: '-35px',
                                        left: '0',
                                        backgroundColor: 'rgba(0, 0, 0, 0.85)',
                                        color: '#fff',
                                        padding: '6px 10px',
                                        borderRadius: '5px',
                                        fontSize: '12px',
                                        whiteSpace: 'nowrap',
                                        zIndex: 1000,
                                        pointerEvents: 'none',
                                        opacity: 1,
                                        boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.3)',
                                    });
                                    tooltip.className = 'custom-tooltip';
                                    e.currentTarget.appendChild(tooltip);
                                }}
                                onMouseLeave={(e) => {
                                    const tooltip = e.currentTarget.querySelector('.custom-tooltip');
                                    if (tooltip) {
                                        e.currentTarget.removeChild(tooltip);
                                    }
                                }}
                            >
                                <img
                                    src={Android} // Path to the image
                                    alt="Data Image"
                                    style={{
                                        width: '22px',
                                        height: '22px',
                                    }}
                                />
                                <span style={{ color: 'white', fontSize: '16px' }}>for Android</span>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

class CustomTooltip extends React.Component {
    render() {
        const { active, payload, label } = this.props;

        if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip" style={{
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    padding: "10px",
                    borderRadius: "5px",
                }}>
                    <p className="label" style={{ margin: 0 }}><strong>{`Category: ${label}`}</strong></p>
                    {payload.map((item, index) => (
                        <p key={index} style={{ margin: 0, color: item.color }}>
                            {
                                item.dataKey === "assigned" ?
                                    `${item.name}: ${item.value}`
                                    : `${item.name}: ${item.value + payload.find(e => e.dataKey === "assigned").value}`
                            }
                        </p>
                    ))}
                </div>
            );
        }

        return null;
    }
}

const mapStateToProps = state => {
    return {
        redux: state,
    };
};


const mapDispatchToProps = dispatch => {
    return {
        searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
        searchBarStyleActivate: (data) => dispatch({ type: ActionTypes.SEARCHBARSTYLE, data: data }),
        userNameStyleActivate: (data) => dispatch({ type: ActionTypes.USERNAMESTYLE, data: data }),
        reuserNameStyleActivate: (data) => dispatch({ type: ActionTypes.REUSERNAMESTYLE, data: data }),
        userTypeStyleActivate: (data) => dispatch({ type: ActionTypes.USERTYPESTYLE, data: data }),
    };
};


// export default windowSize(connect(mapStateToProps, mapDispatchToProps)(DashboardContent));

export default connect(mapStateToProps, mapDispatchToProps)(DashboardContent);

